module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B099THQ6YX.44dceead.jpg";